import React = require("react")
import { Activity, PublicAmorgUser } from "../../../../amorg-common";
import { Flex, FlexItem } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { Button } from "../../../../designSystem/button/Button";
import { ButtonRow } from "../../../../designSystem/button/ButtonRow";
import { CloseModalButton } from "../../../../designSystem/compositeComponents/CloseModalButton";
import { AddExternalParticipantPanel } from "./AddExternalParticipantPanel";
import { Card } from "../../../../designSystem/Card";
import { ParticipantSelector } from "./ParticipantSelector";
import { Modal } from "../../../../designSystem/Modal";
import { Pill } from "../../../../designSystem/pill/Pill";
import { Tabber } from "../../../../designSystem/Tabber";

type MeetingParticipantListProps = {
    users: PublicAmorgUser[];
    activity: Activity;
    participantButtonText:string,
    onParticipantsUpdated(): void;
}
export function MeetingParticipantList(props: MeetingParticipantListProps): JSX.Element {

    const [showUserModal, setShowUserModal] = React.useState(false);

    return (
        
            <Flex flexDirection="row" gap={16}>

                <Flex flexDirection="row" gap={4} flexWrap="wrap">
                    {props.activity.participants.map(p => {
                        return (
                            <FlexItem key={p.id} >
                                <Pill identifier={p.name} variant={p.type.value === "internal" ? "default" : "selected" }>
                                    <Flex flexDirection="column">
                                        <span>{p.name}</span>                                        
                                    </Flex>
                                </Pill>
                                
                            </FlexItem>
                        );
                    })}
                    <Button variant="text" onClick={()=>setShowUserModal(true)} icon="interface_user_team" text={props.participantButtonText} />
                </Flex>


                <Modal 
                    title={"Rediger deltagere"}
                    content={
                        <ParticipantEditor
                            activity={props.activity}
                            onParticipantsUpdated={props.onParticipantsUpdated}
                            onCancel={() => setShowUserModal(false)} />
                    }
                    showModal={showUserModal}
                    onCancel={() => setShowUserModal(false)}/>
               
            </Flex>
    );
}

type ParticipantEditorProps = 
{
    activity:Activity;
    onParticipantsUpdated: () => void;
    onCancel: () => void;
}
function ParticipantEditor(props:ParticipantEditorProps):JSX.Element
{
    const [showInternal, setShowInternal] = React.useState(true);
    const [showAddExternal, setShowAddExternal] = React.useState(false);

    return (
        <Flex flexDirection="column" gap={4} style={{minHeight:'700px'}}>
            <Tabber items=
                {[
                    {tabName:'internals', text:'Deltagere'},
                    {tabName:'externals', text:'Tilføj ekstern'}
                ]}
                selectedTabName={showInternal ? 'internals' : 'externals'}
                onClick={() => {
                    setShowInternal(!showInternal);
                    setShowAddExternal(!showAddExternal);
                }}/>
            <div>
                {showAddExternal &&
                    <Card variant="outlined">
                        <AddExternalParticipantPanel 
                            activityId={props.activity.id}
                            participants={props.activity.participants}
                            onAdded={()=>{
                                props.onParticipantsUpdated();
                                setShowInternal(true);
                                setShowAddExternal(false);
                            }} 
                            onCancel={()=>{setShowAddExternal(false);}} /> 
                    </Card>
                }
            </div>

            <div>

                {showInternal &&
                    <Flex flexDirection="column" gap={4}>
                        
                        <Card variant="outlined">

                            <ParticipantSelector
                                activity={props.activity}
                                onParticipantsUpdated={props.onParticipantsUpdated} />

                            <ButtonRow variant="right-aligned">
                                <CloseModalButton onClose={props.onCancel} />
                            </ButtonRow>
                        </Card>

                        
                    </Flex>
                }
            </div>
        </Flex>
    );
}